<template>
  <div>
    <div class="text-center q-mb-xl">
      <img src="~/assets/logo.svg" style="height: 25px"/>
    </div>

    <q-card class="auth-card relative-position">
      <q-card-main>
        <div v-if="confirmed" class="text-center">
          <check-mark></check-mark>

          <h4>{{ $t('payment_confirmed_title') }}</h4>

          <p>{{ $t('payment_confirmed_body') }}</p>
        </div>

        <template v-else>
          <div v-if="paymentRequiresAction" class="text-center">
            <h4 class="q-mt-none q-mb-md">{{ $t('confirm_payment_title') }}</h4>

            <i18n tag="p" path="confirm_payment_body" class="q-subheading">
              <span place="amount" class="text-bold">{{ paymentAmount }}</span>
            </i18n>

            <q-btn
              color="primary"
              class="q-mt-lg"
              :loading="loading"
              @click="handleConfirmPayment"
            >
              {{ $t('confirm') }}
            </q-btn>
          </div>

          <div v-if="paymentSucceeded" class="text-center">
            <h4 class="q-mt-none q-mb-md">{{ $t('payment_already_confirmed_title') }}</h4>

            <p class="q-subheading">
              {{ $t('payment_already_confirmed_body') }}
            </p>
          </div>

          <div v-if="paymentCanceled" class="text-center">
            <h4 class="q-mt-none q-mb-md">{{ $t('payment_canceled_title') }}</h4>

            <p class="q-subheading">
              {{ $t('payment_canceled_body') }}
            </p>

            <support-btn/>
          </div>

          <div v-if="paymentInvalid" class="text-center">
            <h4 class="q-mt-none q-mb-md">{{ $t('payment_invalid_title') }}</h4>

            <p class="q-subheading">
              {{ $t('payment_invalid_body') }}
            </p>

            <support-btn/>
          </div>
        </template>
      </q-card-main>
    </q-card>
  </div>
</template>

<script>
  import CheckMark from 'components/Common/Animations/Checkmark.vue'
  import { Notify } from 'quasar'
  import { StripePaymentsClient } from 'src/api/StripePayments'
  import SupportBtn from 'src/components/Misc/SupportBtn.vue'
  import { formatMoney } from 'src/utils/format'
  import { getStripeKey } from 'src/utils/stripe'

  export default {
    data () {
      return {
        payment: null,
        loading: false,
        confirmed: false
      }
    },

    computed: {
      paymentSucceeded () {
        return this.payment && this.payment.status === 'succeeded'
      },

      paymentCanceled () {
        return this.payment && this.payment.status === 'canceled'
      },

      paymentRequiresAction () {
        return this.payment && this.payment.status === 'requires_action'
      },

      paymentInvalid () {
        return !this.paymentSucceeded && !this.paymentCanceled && !this.paymentRequiresAction
      },

      paymentAmount () {
        return formatMoney(this.payment.amount, this.payment.currency)
      }
    },

    methods: {
      handleConfirmPayment () {
        this.loading = true

        const stripeInstance = window.Stripe(getStripeKey())

        return stripeInstance.confirmCardPayment(this.payment.client_secret, {
          payment_method: this.payment.payment_method_id
        })
          .then(data => {
            if (data.error) {
              Notify.create({ message: this.$t('payment_confirmation_failed'), type: 'negative' })

              return
            }

            this.confirmed = true
          })
          .finally(() => {
            this.loading = false
          })
      },

      injectStripe () {
        if (this.stripeLoaded || window.Stripe) {
          return
        }

        const scriptSource = 'https://js.stripe.com/v3/'

        let script = document.createElement('script')
        script.setAttribute('src', scriptSource)
        script.onload = () => {
          this.stripeLoaded = true
        }

        document.querySelector('body').appendChild(script)
      }
    },

    beforeRouteEnter (to, from, next) {
      let payment = to.params.payment

      new StripePaymentsClient()
        .get(payment)
        .then(response => {
          next(vm => {
            vm.payment = response.data.data
          })
        })
        .catch(() => {
          next()
        })
    },

    mounted () {
      this.injectStripe()
    },

    components: {
      SupportBtn,
      CheckMark
    }
  }
</script>
